/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { htmlspecialchars, removeMultipleClasses, toggleMultipleClasses, MDTimezones, MDLocale, MPlugins, FireOnceCallbackList } from 'js/entry/util.js';
import { postToBackend } from 'js/entry/base.js';

import { mjt } from 'js/entry/i18ntexts.js';

import { MVMediaMetadata } from 'js/entry/media.js';


/**
 * add extended status info to "expiry_dt" and "inception_dt" meta data fields
 */
MPlugins.register( [], 'ui-expiry-view-49-52', function() {
	return {
		type: 'MediaMetaViewData',
		meta_ids: [ 49, 52 ],
		preSetupViewData: function( media_id, dtinfo, mdd ) {
			if( !dtinfo.is_latest_version ) return null;
			const context = new FireOnceCallbackList;
			postToBackend('json/x_expiry_main/-status', 'media_id='+encodeURIComponent(media_id), function(statusResp) {
				context.fire(media_id,statusResp);
			} );
			return context;
		},
		postSetupViewData: function( media_id, dtinfo, mdd, context ) {
		},
		setupViewData: function( media_id, meta_id, tr, val_arr, val_html, dtinfo, context ) {
			if( !dtinfo.is_latest_version ) return;
			let cbfn = null;
			if( meta_id==49 ) {
				cbfn = function _expired_status_cb( media_id, statusResp ) {
					// console.log({w:'_expired_status_cb',media_id,statusResp});
					tr.removeClass('not-yet-expired');
					const td = tr.children('td');
					let dh = td.children('.data-holder');
					if( !dh.length ) {
						dh = MVMediaMetadata.wrapWithMetaDataHolder(meta_id,val_html+'&nbsp;');
						td.html(dh);
					}
					if( statusResp && !statusResp.error ) {
						let xinfo_str = mjt('unlimited-expiry-dt-applies');
						if( statusResp.explicit_expiry_dt_applies ) xinfo_str = mjt('explicit-expiry-dt-applies','!').replace('%1',MDLocale.fmt_datetime(MDTimezones.datetime_utc2local(statusResp.explicit_expiry_dt)));
						else if( statusResp.auto_expiry_dt_applies ) xinfo_str = mjt('auto-expiry-dt-applies','!').replace('%1',MDLocale.fmt_datetime(MDTimezones.datetime_utc2local(statusResp.auto_expiry_dt)));
						if( statusResp.explicit_expiry_dt_applies || statusResp.auto_expiry_dt_applies ) {
							const m = dtinfo.meta || {};
							const expired_dt = m[51] && m[51][0] ? m[51][0] : '';
							if( !expired_dt ) {
								tr.addClass('not-yet-expired');
								xinfo_str += ', '+mjt('not-yet-expired','!');
							}
						}
						dh.find('.xinfo').remove().end().append('&nbsp;<span class="xinfo">'+xinfo_str+'&nbsp;</span>');
						tr.removeClass('md-hide').addClass('md-avl');
					}
				};
			} else if( meta_id==52 ) {
				cbfn = function _inception_status_cb( media_id, statusResp ) {
					// console.log({w:'_inception_status_cb',media_id,j});
					tr.removeClass('not-yet-incepted');
					const td = tr.children('td');
					let dh = td.children('.data-holder');
					if( !dh.length ) {
						dh = MVMediaMetadata.wrapWithMetaDataHolder(meta_id,val_html+'&nbsp;');
						td.html(dh);
					}
					if( statusResp && !statusResp.error ) {
						let xinfo_str = mjt('unlimited-inception-dt-applies');
						if( statusResp.explicit_inception_dt_applies ) xinfo_str = mjt('explicit-inception-dt-applies','!').replace('%1',MDLocale.fmt_datetime(MDTimezones.datetime_utc2local(statusResp.explicit_inception_dt)));
						else if( statusResp.auto_inception_dt_applies ) xinfo_str = mjt('auto-inception-dt-applies','!').replace('%1',MDLocale.fmt_datetime(MDTimezones.datetime_utc2local(statusResp.auto_inception_dt)));
						if( statusResp.explicit_inception_dt_applies || statusResp.auto_inception_dt_applies ) {
							const m = dtinfo.meta || {};
							const incepted_dt = m[53] && m[53][0] ? m[53][0] : '';
							if( !incepted_dt ) {
								tr.addClass('not-yet-incepted');
								xinfo_str += ', '+mjt('not-yet-incepted','!');
							}
						}
						dh.find('.xinfo').remove().end().append('&nbsp;<span class="xinfo">'+xinfo_str+'&nbsp;</span>');
						tr.removeClass('md-hide').addClass('md-avl');
					}
				};
			}
			if( cbfn && context ) {
				context.add(cbfn);
			}
		},
	};
} );



/**
 * - force reset of "expired_dt" (51) and "advised_of_expiry_dt" (50) when updating "expiry_dt" (49)
 * - force reset of "incepted_dt" (53) when updating "inception_dt" (52)
 */
MPlugins.register( [], 'ui-expiry-save-49-52', function() {
	return {
		type: 'MediaMetaSaveData',
		meta_ids: [ 49, 52 ],
		beforeSaveMetaData: function( media_id, meta_id, data, cur_data ) {
			if( meta_id==49 ) {
				data.meta[51] = [''];
				data.meta[50] = [''];
			} else if( meta_id==52 ) {
				data.meta[53] = [''];
			}
		},
	};
} );


/**
 * - add extended status info to "expiry_dt" field in edit mode
 * - add extended status info to "inception_dt" field in edit mode
 */
MPlugins.register( [], 'ui-expiry-edit-49-52', function() {
	return {
		type: 'MediaMetaEditView',
		meta_ids: [ 49, 52 ],
		setupEditView: function( media_id, meta_id, btns_div, wdgs_div, val_arr, dtinfo ) {
			const m = dtinfo.meta || {};
			let xinfo_str = '';
			if( meta_id==49 ) {
				const expired_dt = m[51] && m[51][0] ? m[51][0] : '';
				const advised_of_expiry_dt = m[50] && m[50][0] ? m[50][0] : '';
				if( expired_dt ) xinfo_str = mjt('hint-on-edit-expiry_dt-after-expired','!');
				else if( advised_of_expiry_dt ) xinfo_str = mjt('hint-on-edit-expiry_dt-after-advised_of_expiry','!');
			} else if( meta_id==52 ) {
				const incepted_dt = m[53] && m[53][0] ? m[53][0] : '';
				if( incepted_dt ) xinfo_str = mjt('hint-on-edit-inception_dt','!');
			}
			if( xinfo_str ) {
				const after_div = btns_div || wdgs_div;
				if( after_div ) after_div.after('<div class="edit-xinfo emph">'+htmlspecialchars(xinfo_str)+'</div>');
			}
		},
	};
} );


/**
 * add expiry-related status info to thumbnail views
 */
MPlugins.register( [], 'ui-expiry-thumb-view', function() {

	var m_ovl_template = null;
	function createOverlayNode() {
		// <div class="media-overlay-1 media-overlay-1-expiry keep"><div class="icon"></div></div>
		if( m_ovl_template===null ) {
			m_ovl_template = document.createElement('div');
			m_ovl_template.className = 'media-overlay-1 media-overlay-1-expiry keep';
			const icon_div = document.createElement('div');
			icon_div.className = 'icon';
			m_ovl_template.appendChild(icon_div);
		}
		return m_ovl_template.cloneNode(true);
	}

	return {
		type: 'MediaThumbnailView',
		meta_ids: [ 50,51,52,53 ],
		bindStatusChanged: function( view_mode, cb ) {
		},
		queryMediaViewStatus: function( view_mode, media_ids, meta, trigger_status_change ) {
		},
		resetViewNode: function( view_mode, node, media_id ) {
			if( view_mode==='link' ) return; // ignored here
			removeMultipleClasses( node, ['not-yet-incepted','expired','advised-of-expiry'] );
		},
		updateViewNode: function( view_mode, node, media_id, meta ) {
			if( view_mode==='link' ) return; // ignored here
			// view_mode is one of: 'result', 'mj-thumb-box', 'link'
			const incepted			= !!(meta[52]&&meta[52][0]) && !(meta[53]&&meta[53][0]);		// inception_dt = meta[52]?meta[52][0]:'',
			const expired			= !!(meta[51]&&meta[51][0]);									// expired_dt = meta[51]?meta[51][0]:'',
			const advised_of_expiry	= !!(meta[50]&&meta[50][0]);									// advised_of_expiry_dt = meta[50]?meta[50][0]:'',
			if( incepted || expired || advised_of_expiry ) {
				// add overlay divs
				if( view_mode==='result' ) {
					if( node.find('.media-overlay-1-expiry').length===0 ) node.find('.thumbnail').append( createOverlayNode() );
				} else if( view_mode==='mj-thumb-box' ) {
					if( node.find('.media-overlay-1-expiry').length===0 ) node.append( createOverlayNode() );
				}
				// set expiration-related classes
				toggleMultipleClasses( node, {'not-yet-incepted':incepted,'expired':expired,'advised-of-expiry':advised_of_expiry} );
			} else {
				removeMultipleClasses( node, ['not-yet-incepted','expired','advised-of-expiry'] );
			}
		},
		initViewNodesRoot: function( view_mode, root_node, on_action ) {
			//if( view_mode==='result' || view_mode==='mj-thumb-box' ) {
			//}
		},
	};
} );


